import { IBatchRecord, IBatchDetails, IBatchNote, IProperty, ITarget } from './iBatchTypes';
import { IMachine } from './iMachineTypes';

export class BatchRecord implements IBatchRecord {
  batch_notes?: IBatchNote[];
  created_at?: string;
  details?: IBatchDetails;
  gateway_id?: string;
  machine?: IMachine;
  machine_id?: string;
  note?: string;
  origin?: string;
  property?: IProperty;
  target?: ITarget;
  time?: string;

  constructor(data: Partial<IBatchRecord>) {
    Object.assign(this, data);
  }
}
